import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable, take } from 'rxjs';
import { mergeMap } from 'rxjs/operators';
import { Logger, LoggerFactory } from '@rillion/core/logger';
import { Store } from '@ngrx/store';
import { AuthSelectors } from '@rillion/store/auth';
import { AppSettingsService } from '@rillion/core';

/**
 * The interceptor for adding token to the authorization header of API calls
 */
@Injectable()
export class JwtInterceptor implements HttpInterceptor {
  /**
   * Property being used for logging different events
   */
  private readonly logger: Logger;

  constructor(
    private readonly store: Store,
    private readonly appSettingsService: AppSettingsService,
    loggerFactory: LoggerFactory,
  ) {
    this.logger = loggerFactory.getLogger('JwtInterceptor');
    this.logger.info('JwtInterceptor is started');
  }

  /**
   * Adds the authorization header for http requests being sent
   * @param request Request that is being sent
   * @param next HttpHandler
   * @returns Observable of HttpEvent -> depending on what the outcome will be
   */
  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // Add the authorization header only for requests to our server!
    // Skip urls for Non-Rillion server
    const reg = new RegExp(this.appSettingsService.appSettings.baseUrl);
    if (!request.url.match(reg)) {
      return next.handle(request);
    }

    return this.store.select(AuthSelectors.selectUser).pipe(
      take(1),
      mergeMap((currentUser: any) => {
        if (currentUser && currentUser.token) {
          request = request.clone({
            headers: request.headers.set('Authorization', `Bearer ${currentUser.token}`),
          });
        }
        return next.handle(request);
      }),
    );
  }
}
